import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const ComingSoonComponent = () => {
  return (
    <Box 
      sx={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 8
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 700,
          width: '100%',
          p: 6,
          borderRadius: 2,
          textAlign: 'center',
          overflow: 'hidden'
        }}
      >
        {/* <Box sx={{ mb: 4 }}>
          <svg width="220" height="220" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="110" cy="110" r="110" fill="#f0f7ff" />
            <path d="M110 40C71.4 40 40 71.4 40 110C40 148.6 71.4 180 110 180C148.6 180 180 148.6 180 110C180 71.4 148.6 40 110 40Z" fill="#e1effe" />
            <rect x="75" y="85" width="70" height="90" rx="4" fill="#3f83f8" />
            <rect x="83" y="95" width="54" height="5" rx="2.5" fill="white" />
            <rect x="83" y="105" width="40" height="5" rx="2.5" fill="white" />
            <rect x="83" y="115" width="54" height="5" rx="2.5" fill="white" />
            <rect x="83" y="125" width="30" height="5" rx="2.5" fill="white" />
            <rect x="83" y="145" width="54" height="10" rx="5" fill="#bee3f8" />
            <circle cx="150" cy="70" r="25" fill="#3f83f8" />
            <path d="M142 70L148 76L158 66" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Box> */}

    <Box sx={{ mb: 4 }}>
          <svg width="220" height="220" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="110" cy="110" r="110" fill="#f0f7ff" />
            <path d="M110 40C71.4 40 40 71.4 40 110C40 148.6 71.4 180 110 180C148.6 180 180 148.6 180 110C180 71.4 148.6 40 110 40Z" fill="#e1effe" />
            
            {/* Chat bubble with AI brain */}
            <rect x="60" y="85" width="100" height="75" rx="10" fill="#3f83f8" />
            <path d="M85 160L70 175L70 150" fill="#3f83f8" />
            
            {/* Text lines in chat */}
            <rect x="75" y="100" width="70" height="6" rx="3" fill="white" />
            <rect x="75" y="112" width="50" height="6" rx="3" fill="white" />
            <rect x="75" y="124" width="60" height="6" rx="3" fill="white" />
            <rect x="75" y="136" width="40" height="6" rx="3" fill="white" />
            
            {/* AI brain icon */}
            <circle cx="150" cy="70" r="25" fill="#3f83f8" />
            <path d="M145 60C145 60 137 70 145 80M155 60C155 60 163 70 155 80" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M150 62V78" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M143 65H157" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M143 73H157" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
            
            {/* WhatsApp template icon */}
            <rect x="130" y="130" width="35" height="40" rx="5" fill="#25D366" />
            <circle cx="147" cy="142" r="5" fill="white" />
            <rect x="139" y="152" width="17" height="3" rx="1.5" fill="white" />
            <rect x="137" y="158" width="21" height="3" rx="1.5" fill="white" />
          </svg>
        </Box>
        
        
        <Typography variant="h4" component="h1" fontWeight="700" gutterBottom color="primary">
          Create Template GenAI Coming Soon
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, maxWidth: 500, mx: 'auto', color: 'text.secondary' }}>
          We're currently developing an advanced AI-powered template creation tool. This feature will be available soon, helping you design engaging WhatsApp templates with intelligent content suggestions and optimizations.
        </Typography>
        
        
      </Paper>
    </Box>
  );
};

export default ComingSoonComponent;